import { render, staticRenderFns } from "./GoodsStatistics.vue?vue&type=template&id=77a8307a&scoped=true"
import script from "./GoodsStatistics.vue?vue&type=script&lang=js"
export * from "./GoodsStatistics.vue?vue&type=script&lang=js"
import style0 from "./GoodsStatistics.vue?vue&type=style&index=0&id=77a8307a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a8307a",
  null
  
)

export default component.exports